import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const PopoverContent = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1ou9t1b-0"
})(["padding:", ";", " overflow:visible;"], ({
  theme,
  $padding
}) => theme.spacing[$padding].default, isMobile(css(["padding:", ";"], ({
  theme,
  $padding
}) => theme.spacing[$padding].mobile)));
PopoverContent.displayName = 'PopoverContent';
const PopoverScrollContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1ou9t1b-1"
})(["overflow-x:auto;"]);
PopoverScrollContainer.displayName = 'PopoverScrollContainer';
const ChildrenWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1ou9t1b-2"
})(["width:100%;"]);

export { ChildrenWrapper as C, PopoverScrollContainer as P, PopoverContent as a };
//# sourceMappingURL=PopoverContentContainer.styles-BvNPiXYs.js.map
